export default "__VITE_ASSET__JpNW5Zrz__"